import {CSSProperties, FC} from 'react';


export interface IIconEcoBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconEcoBmw: FC<IIconEcoBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M2 11.664A5.67 5.67 0 0 1 7.664 6H22v5.664a5.67 5.67 0 0 1-5.664 5.664H2v-5.664Zm3.086 2.757h3.94v-1.324H6.604v-.872h2.01v-1.23h-2.01v-.78h2.352V8.893h-3.87v5.529Zm8.2-.288c.203-.11.383-.244.541-.405a1.58 1.58 0 0 0 .355-.545l-1.239-.74a.984.984 0 0 1-.4.526.912.912 0 0 1-.27.116 1.121 1.121 0 0 1-.272.035.914.914 0 0 1-.471-.12 1.118 1.118 0 0 1-.35-.323 1.485 1.485 0 0 1-.219-.468 2.041 2.041 0 0 1-.074-.553c0-.171.021-.344.063-.518a1.45 1.45 0 0 1 .198-.467c.091-.137.206-.249.343-.335a.917.917 0 0 1 .495-.128c.083 0 .173.01.272.03a.932.932 0 0 1 .526.32c.075.089.136.2.183.335l1.16-.825a2.058 2.058 0 0 0-.818-.876c-.368-.221-.799-.331-1.292-.331-.42 0-.796.08-1.125.241a2.692 2.692 0 0 0-1.367 1.51 2.885 2.885 0 0 0 .015 2.041c.13.343.31.65.542.919.23.27.507.487.829.65.322.164.675.246 1.06.246.217 0 .44-.029.669-.086.228-.057.444-.14.646-.25Zm5.662-.518a2.883 2.883 0 0 0 .747-1.935 2.97 2.97 0 0 0-.72-1.94 2.666 2.666 0 0 0-.833-.638 2.395 2.395 0 0 0-1.079-.241c-.39 0-.746.076-1.07.23a2.735 2.735 0 0 0-1.402 1.506 2.933 2.933 0 0 0-.008 2.095c.127.338.306.637.537.9.231.262.509.473.833.634.325.161.684.241 1.079.241.39 0 .748-.077 1.075-.233.327-.156.607-.362.84-.62Zm-1.071-2.967c.09.132.16.285.206.46.047.173.07.354.07.54 0 .182-.022.361-.066.538-.044.176-.11.334-.198.471-.089.138-.203.25-.343.335a.937.937 0 0 1-.498.128.944.944 0 0 1-.491-.124 1.107 1.107 0 0 1-.35-.327 1.417 1.417 0 0 1-.207-.464 2.194 2.194 0 0 1 0-1.074c.044-.174.112-.33.203-.468.09-.137.205-.248.342-.33a.94.94 0 0 1 .495-.125c.187 0 .35.04.49.12.14.081.256.187.347.32Z" clipRule="evenodd" />
        </svg>
    );
};
